import { render, staticRenderFns } from "./clientGroupForm.vue?vue&type=template&id=10651047&scoped=true&"
import script from "./clientGroupForm.vue?vue&type=script&lang=js&"
export * from "./clientGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./clientGroupForm.vue?vue&type=style&index=0&id=10651047&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10651047",
  null
  
)

export default component.exports